import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';


@Component({
    selector: 'app-single-view-escort',
    templateUrl: './single-escort.html'
})

export class SingleViewEscortComponent {
    orgID: string;
    vendorID: string;
    escortID: string;
    employeeData: any;
    profile: any;
    defaultEmpImage = "../../../../../../../assets/images/home/employee.png";

    constructor(
        public api: ApiService,
        public router: Router,
        public route: ActivatedRoute,
        public swal: SweetAlert,
        public storage: StorageService,
        public file: FileUploadService,

    ) {
        this.orgID = this.storage.get('userInfo').orgID;
        this.route.paramMap.subscribe((params: any) => {
            this.escortID = params.params.escortID;
        });
    }
    ngOnInit() {
        this.getEmployeeData();
    }
    getEmployeeData() {
        const obj = {
            orgID: this.orgID,
            // vendorID: this.vendorID,
            escortID: this.escortID
        };
        this.api.transportManagerEscortList(obj).then((res: any) => {
            if (res.status == 'success') {
                this.employeeData = res.data[0];
                // this.profile = this.convertURLintoImg(this.employeeData.profilePic);

            }
        }).catch((err) => {
            console.log(err);
        });

    }

    async convertURLintoImg(url) {
        let imageFile = await this.file.urlHandleBase64(url);
        return imageFile;
    }
}
